import React, { useState } from 'react';
import axios from 'axios';
import '../assets/css/contactus.css'; // Ensure this path is correct

const ContactUs = () => {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [formStatus, setFormStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.email || !formData.message) {
            setFormStatus({ type: 'error', message: 'Please fill in all fields.' });
            return;
        }
        try {
            await axios.post('/api/contact', formData);
            setFormStatus({ type: 'success', message: 'Thank you for reaching out! We will get back to you soon.' });
            setFormData({ name: '', email: '', message: '' });
        } catch (error) {
            console.error('Error submitting contact form:', error);
            setFormStatus({ type: 'error', message: 'Failed to submit the form. Please try again later.' });
        }
    };

    return (
        <div className="contact-page">
            <div className="contact-header">
                <h1>Contact Us</h1>
                <p>We'd love to hear from you! Please fill out the form below, and we’ll get back to you shortly.</p>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Your Name</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Your Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="message">Your Message</label>
                    <textarea
                        id="message"
                        name="message"
                        placeholder="Write your message here"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>
                </div>
                {formStatus && (
                    <p className={`form-status ${formStatus.type}`}>
                        {formStatus.message}
                    </p>
                )}
                <button type="submit" className="submit-button">Send Message</button>
            </form>
        </div>
    );
};

export default ContactUs;